import { Component, Prop, Watch } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { ColourTheme, UserPreferences, defaultThemeColours } from '@/app-modules/store/modules/user-preferences';
import { IColourThemeSelection, DefaultColourThemeSelections } from '@/components/user-settings/_components/colour-theme/_domain/models';
import { Chrome } from 'vue-color';
import { mixin as clickaway } from 'vue-clickaway2';

@Component({
  name: 'ColourThemeComponent',
  components: {
    colourpicker: Chrome
  },
  mixins: [clickaway]
})
export default class ColourThemeComponent extends TombolaBaseComponent {
  @Prop() private userPreferences: UserPreferences;
  private colourThemeSelections: IColourThemeSelection[] = [];
  private selectedColourTheme: ColourTheme = null;
  private backgroundColour: { hex?: string } = {};
  private backgroundColourPickerVisible: boolean = false;
  private chatBackgroundColour: { hex?: string } = {};
  private chatBackgroundColourPickerVisible: boolean = false;

  private get backgroundColourStyle() {
    return this.getStyleForColour(this.backgroundColour);
  }

  private get chatBackgroundColourStyle() {
    return this.getStyleForColour(this.chatBackgroundColour);
  }

  protected created() {
    this.initialiseColourThemeSelections();
    this.selectedColourTheme = this.userPreferences.colourTheme;
    this.$nextTick(() => {
      this.backgroundColour.hex = this.userPreferences.backgroundColour;
      this.chatBackgroundColour.hex = this.userPreferences.chatBackgroundColour;
    });
  }

  @Watch('selectedColourTheme')
  private onSelectedColourThemeChanged(): void {
    const themeColours = defaultThemeColours[this.selectedColourTheme];
    this.backgroundColour = { hex: themeColours.backgroundColour };
    this.chatBackgroundColour = { hex: themeColours.chatBackgroundColour };
  }

  public saveSettings(): void {
    this.userPreferences.colourTheme = this.selectedColourTheme;
    this.userPreferences.backgroundColour = this.backgroundColour.hex;
    this.userPreferences.chatBackgroundColour = this.chatBackgroundColour.hex;
  }

  private initialiseColourThemeSelections(): void {
    this.colourThemeSelections = DefaultColourThemeSelections.map((o) => ({
      colourTheme: o.colourTheme,
      friendlyName: o.friendlyName
    }));
  }

  private toggleBackgroundColourPicker(): void {
    this.backgroundColourPickerVisible = !this.backgroundColourPickerVisible;
  }

  private hideBackgroundColourPicker(): void {
    this.backgroundColourPickerVisible = false;
  }

  private toggleChatBackgroundColourPicker(): void {
    this.chatBackgroundColourPickerVisible = !this.chatBackgroundColourPickerVisible;
  }

  private hideChatBackgroundColourPicker(): void {
    this.chatBackgroundColourPickerVisible = false;
  }

  private getStyleForColour(colourSelection: { hex?: string }): { [key: string]: string } {
    return {
      'background-color': colourSelection.hex
    };
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/user-settings/_components/colour-theme/colour-theme.component.ts